import React from "react";
import Typography from "@mui/material/Typography";
import { FormControl, MenuItem, Select, Stack } from "@mui/material";
import { useTeams } from "src/scenes/teams/teams-provider";
import styled from "styled-components";

const StyledMenuItem = styled(MenuItem)`
    font-size: 12px;
`;

const TeamPicker = ({ selectedTeam, setSelectedTeam }) => {
    const teamsApi = useTeams();

    const handleTeamChange = (event) => {
        setSelectedTeam(event.target.value);
    };

    return (
        <Stack
            direction="column"
            sx={{
                width: "100%",
                typography: "body1",
                paddingTop: "26px",
            }}
            spacing={2}
            justifyContent="space-between"
        >
            <Typography id="modal-modal-title" style={{ fontSize: "12px", fontWeight: "200" }}>
                Select a team
            </Typography>
            <Stack direction="row" alignItems="center">
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <Select
                        value={selectedTeam}
                        onChange={handleTeamChange}
                        displayEmpty
                        inputProps={{ "aria-label": "select team" }}
                        sx={{ fontSize: 12 }}
                    >
                        {teamsApi &&
                            teamsApi.data &&
                            teamsApi.data.map((orgTeam) => {
                                return (
                                    <StyledMenuItem value={orgTeam.id}>
                                        {orgTeam.name}
                                    </StyledMenuItem>
                                );
                            })}
                    </Select>
                </FormControl>
            </Stack>
        </Stack>
    );
};

export default TeamPicker;
